export const GIT_COMMIT_KEY = 'GIT_COMMIT_KEY';
